var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSquare42AError = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 60 60",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M14 16.5a2.5 2.5 0 0 1 2.5-2.5h15a2.5 2.5 0 0 1 2.5 2.5v15a2.5 2.5 0 0 1-2.5 2.5h-15a2.5 2.5 0 0 1-2.5-2.5v-15Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "m50 12-7.251-.725A2.5 2.5 0 0 0 40 13.762V37.5a2.5 2.5 0 0 1-2.5 2.5H13.762a2.5 2.5 0 0 0-2.487 2.749L12 50h35.5a2.5 2.5 0 0 0 2.5-2.5V12Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#f39898",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M50 11v36.5a2.5 2.5 0 0 1-2.5 2.5H11"
})));
SvgSquare42AError.viewBox = '0 0 60 60';
const ForwardRef = /*#__PURE__*/forwardRef(SvgSquare42AError);
export default ForwardRef;